const values = [2, 3, 4, 6, 8, 16, 24];
export default values.map(v => `mdl-shadow--${v}dp`);



// WEBPACK FOOTER //
// /Users/tleunen/dev/react-mdl/src/utils/shadows.js